// src/components/OfferServiceManagement/OfferServiceList.js
import React, { useState, useEffect } from "react";
import OfferServiceTable from "./OfferServiceTable";
import Select from "react-select";
import "./OfferServiceList.css";
import SearchComponent from "../../../components/SearchComponent";
import { OfferServiceService } from "../../../services/offerServiceService";
import { Modal, Spin } from "antd";
import AddOfferServiceForm from "./AddOfferServiceForm";
import { toast } from "react-toastify";
// import ImportOfferServicesForm from "./ImportOfferServicesForm";
import ButtonComponent from "../../../components/ButtonComponent/ButtonComponent";
import {
  IconAdd,
  // IconUpload
} from "../../../assets/icons";
import debounce from "lodash.debounce";

const OfferServiceList = () => {
  const [offerServices, setOfferServices] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [search, setSearch] = useState("");
  const [order, setOrder] = useState("asc");
  const [totalRecord, setTotalRecord] = useState(0);
  const [columns, setColumns] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false); // Trạng thái modal
  // const [isImportModalVisible, setIsImportModalVisible] = useState(false); // Trạng thái modal

  const [loading, setLoading] = useState(false);
  const [editingOfferService, setEditingOfferService] = useState(null);
  const [selectedOfferServices, setSelectedOfferServices] = useState([]);

  const fetchOfferServices = async () => {
    try {
      setLoading(true);
      const response = await OfferServiceService.getOfferServices({
        page: currentPage,
        pageSize: pageSize,
        search: search,
        order: order,
      });
      if (!response.Data) {
        toast.error("Lỗi lấy danh sách ưu đãi/dịch vụ!");
        return;
      }
      const { totalRecord, columns, listData } = response.Data;
      setTotalRecord(totalRecord);
      setColumns(columns);
      setOfferServices(listData);
    } catch (error) {
      toast.error("Lỗi lấy danh sách ưu đãi/dịch vụ!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOfferServices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, pageSize, search, order]);

  const handleSearchChange = debounce((value) => {
    setSearch(value);
  }, 500);

  const handleOrderChange = (selectedOption) => {
    setOrder(selectedOption.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePageSizeChange = (e) => {
    setPageSize(e.target.value);
  };

  const showModal = () => {
    setIsModalVisible(true); // Mở modal khi nhấn nút Thêm ưu đãi/dịch vụ
  };

  // const showImportModal = () => {
  //   setIsImportModalVisible(true); // Mở modal khi nhấn nút Thêm ưu đãi/dịch vụ
  // };

  const handleCancel = () => {
    setEditingOfferService(null);
    setIsModalVisible(false); // Đóng modal khi nhấn Huỷ
  };

  // const handleImportCancel = () => {
  //   setIsImportModalVisible(false); // Đóng modal khi nhấn Huỷ
  // };

  const handleAddOfferService = async (offerServiceData) => {
    try {
      setLoading(true);
      // Gọi API thêm ưu đãi/dịch vụ
      const response = await OfferServiceService.addOfferService(
        offerServiceData
      );
      if (response.Data) {
        setIsModalVisible(false); // Đóng modal
        fetchOfferServices(); // Lấy lại danh sách ưu đãi/dịch vụ sau khi thêm
      } else {
        toast.error("Có lỗi xảy ra!");
      }
    } catch (error) {
      toast.error("Có lỗi xảy ra khi thêm ưu đãi/dịch vụ!");
    } finally {
      setLoading(false);
    }
  };

  // const handleImportOfferServices = async (formData) => {
  //   setLoading(true);
  //   try {
  //     const response = await OfferServiceService.importOfferServices(formData);
  //     if (response.Data) {
  //       toast.success("Tải lên ưu đãi/dịch vụ thành công!");
  //       fetchOfferServices(); // Cập nhật danh sách ưu đãi/dịch vụ
  //       handleImportCancel();
  //     } else {
  //       toast.error(response.message || "Tải lên thất bại!");
  //     }
  //   } catch (error) {
  //     toast.error("Có lỗi xảy ra!");
  //     console.error(error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleEditOfferService = async (id, updatedOfferService) => {
    try {
      setLoading(true);
      const response = await OfferServiceService.updateOfferService(
        id,
        updatedOfferService
      );
      if (response.Data) {
        fetchOfferServices(); // Gọi API để làm mới danh sách
      } else {
        toast.error("Có lỗi xảy ra!");
      }
    } catch (error) {
      toast.error("Có lỗi xảy ra!");
      console.error(error);
    } finally {
      setIsModalVisible(false); // Đóng modal
      setLoading(false);
    }
  };

  const handleDeleteSelectedOfferServices = async () => {
    if (selectedOfferServices.length === 0) return;
    try {
      const confirmDelete = window.confirm(
        `Bạn có chắc chắn muốn xóa ${selectedOfferServices.length} ưu đãi/dịch vụ đã chọn?`
      );
      if (!confirmDelete) return;
      setLoading(true);
      const response = await OfferServiceService.deleteSelectedOfferServices(
        selectedOfferServices
      );
      if (response.Status === 200) {
        toast.success("Xóa ưu đãi/dịch vụ thành công!");
        setSelectedOfferServices([]); // Xóa danh sách ưu đãi/dịch vụ đã chọn
        fetchOfferServices();
      } else {
        toast.error("Xóa ưu đãi/dịch vụ thất bại!");
      }
    } catch (error) {
      console.error("Error deleting selected offerServices:", error);
      toast.error("Có lỗi xảy ra khi xóa ưu đãi/dịch vụ!");
      setLoading(false);
    }
  };

  return (
    <div className="p-4 flex flex-col gap-2">
      <div className="flex flex-col gap-4">
        <h1 className="font-bold text-lg">Quản lý ưu đãi/dịch vụ</h1>
        <div className="flex gap-2">
          <ButtonComponent
            label={"Thêm ưu đãi/dịch vụ"}
            prefix={<IconAdd className="w-4 h-4 fill-white" />}
            onClick={() => showModal()}
          />
          {/* Modal thêm ưu đãi/dịch vụ */}
          <Modal
            title={
              editingOfferService
                ? "Chi tiết ưu đãi/dịch vụ"
                : "Thêm ưu đãi/dịch vụ"
            }
            open={isModalVisible}
            onCancel={handleCancel}
            footer={null}
            width={800}
            destroyOnClose={true}
          >
            <AddOfferServiceForm
              onAddOfferService={handleAddOfferService}
              onEditOfferService={handleEditOfferService}
              loading={loading}
              initialValues={editingOfferService}
            />
          </Modal>
          {/* <ButtonComponent
            label={"Tải ưu đãi/dịch vụ"}
            prefix={<IconUpload className="w-4 h-4 fill-white" />}
            className={"!bg-green-500"}
            onClick={() => showImportModal()}
          />

          Modal Import ưu đãi/dịch vụ
          <Modal
            title="Tải ưu đãi/dịch vụ"
            open={isImportModalVisible}
            onCancel={handleImportCancel}
            footer={null}
            width={600}
          >
            <ImportOfferServicesForm
              onImport={handleImportOfferServices}
              loading={loading}
            />
          </Modal> */}
          <button
            className="ring-1 ring-red-500 rounded-lg py-1 px-4 text-red-500"
            disabled={selectedOfferServices.length === 0}
            onClick={handleDeleteSelectedOfferServices}
          >
            Xoá mục đã chọn
          </button>
          <div className="flex-1">
            <SearchComponent
              onChange={handleSearchChange}
              isSearchOnEnter={false}
            />
          </div>
          <Select
            options={[
              { value: "", label: "Mặc định" },
              { value: "asc", label: "A-Z" },
              { value: "desc", label: "Z-A" },
            ]}
            onChange={handleOrderChange}
            placeholder="Sắp xếp"
          />
        </div>
      </div>
      <Spin spinning={loading}>
        <OfferServiceTable
          offerServices={offerServices}
          columns={columns}
          onPageChange={handlePageChange}
          totalRecord={totalRecord}
          currentPage={currentPage}
          onPageSizeChange={handlePageSizeChange}
          pageSize={pageSize}
          refetchData={fetchOfferServices}
          setIsModalVisible={setIsModalVisible}
          setEditingOfferService={setEditingOfferService}
          selectedOfferServices={selectedOfferServices}
          setSelectedOfferServices={setSelectedOfferServices}
        />
      </Spin>
    </div>
  );
};

export default OfferServiceList;
